<template>
    <main class="DataUsageWarning-MAIN">

        <section>
            <div>
                <h1>Uso de datos</h1>
                <div>
                    Utilizamos cookies estrictamente necesarias para la funcionalidad del sitio y análisis anónimo.
                    <br/>No hay rastreadores publicitarios ni recoleccción de datos personales sin consentimiento explicito.
                    <br/><p @click="goToPrivacyNote()">Leer nuestro anuncio de privacidad</p>
                </div>
            </div>
            <div>
                <button @click="confirmDataUsage(true)">ACEPTAR</button>
            </div>
        </section>

    </main>
</template>

<script>
export default {
    name: 'DataUsageWarning',
    data(){
        return {
        }
    },
    methods: {

        confirmDataUsage(status){
            const userData = JSON.parse(localStorage.getItem("userData") || '{}');
            userData.dataUsageAccepted = status;
            localStorage.setItem("userData", JSON.stringify(userData));
            //this.$parent.confirmedDataUsage = true;
            this.$emit('confirmed-data-usage');
        },

        goToPrivacyNote(){
            this.$router.push({ name: 'privacy' });
        },
    }
}
</script>

<style scoped lang="stylus">
.DataUsageWarning-MAIN
    height: 100vh
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    background-color: rgba(0, 0, 0, 0.5)
    position: fixed
    top: 0
    left: 0
    z-index: 3

    >section
        background-color: white
        border-radius: 5vw
        padding: 5vw
        width: calc(100vw - 10vw - 4vw)
        min-height: calc(100vw - 10vw - 4vw)
        display: flex
        flex-direction: column
        justify-content: space-between

        >div:first-child
            font-family: "Archivo ExtraCondensed", sans-serif

            h1
                margin: 0
                font-weight: normal

            >div
                margin-top: 0.5ch

                >p
                    margin: 0
                    text-decoration: underline
        
        >div:last-child
            display: flex
            flex-direction: column

            >button
                border-radius: 100vw
                border: none
                font-family: "DM Mono", monospace
                color: white
                padding: 1ch 0
                margin-bottom: 1ch
            
                &:first-child
                    background-color: #015AFF

                //&:last-child
                //    background-color: #DCDCDC
</style>